import { createStore } from 'vuex'
import axios from "@/plugins/axios";
import Toast from "@/plugins/toast";
import Swal from "sweetalert2";
import {useFavicon} from "@vueuse/core";
export default createStore({
  state: {
    siteName:'سامانه مدیریت آموزشی مبینک',
    user:{
      'name':localStorage.getItem('name'),
      'last_name':localStorage.getItem('last_name'),
      'id':localStorage.getItem('id'),
      'token':localStorage.getItem('token'),
      'access':localStorage.getItem('access'),
      'avatar':localStorage.getItem('avatar'),
      'status':localStorage.getItem('status'),
      'has_profile':localStorage.getItem('has_profile'),
    },
    api:process.env.VUE_APP_BACKEND+'/api/',
    url:process.env.VUE_APP_BACKEND,
    frontUrl:process.env.VUE_APP_FRONT,
    errors:[],
    permissions:[],
    userPermissions:[],
    searchResult:[],
    searchRequest:false,
    toggleAside:false,
    toggleNav:false,
    toggleSearch:false,
    configSite:{
      'logo':null,
      'footer_logo':null,
      'site_name':null,
      'site_url':null,
      'site_name_ir':null,
      'comment_rule':null,
      'email':null,
      'support_phone':null,
      'site_address':null,
      'enamad':null,
      'samandehi':null,
      'site_bio':null,
      'copy_right':null,
      'social_media':{
        'telegram':null,
        'whatsapp':null,
        'instagram':null,
        'twitter':null,
        'facebook':null,
      }
    },
  },
  mutations: {
    paginate(state, {current_page, to, per_page, last_page}){
      state.current = current_page;
      state.next = to;
      state.previous = per_page;
      state.total = last_page;
    },

    handleError(state,payload){
    
      const response = payload.response;
      if(response === undefined || response.status === 500){
        let msg = response !== undefined ? response.data.msg : null;
        if(msg){
          Toast.error(msg)
        }else{
          Toast.error('یک خطای غیر منتظره رخ داده است')
        }
      }else if(response.status === 422 || response.status === 413){
        state.errors = Object.values(response.data.errors)
        state.validationErrorModal = true;
      }else if(response.status === 403){
        // window.location.href = `/error/${response.status}/دسترسی شما غیر مجاز است برای بررسی بیشتر با ما تماس بگیرید`;
      }else if(response.status === 401){
        // window.location.href = `/error/${response.status}/توکن شما منقضی شده است لطفا دوباره وارد شوید`;
      }else if(response.status === 404){
        // window.location.href = `/error/${response.status}/ صفحه مورد پیدا نشد`;
      }
    },

    async setStorage(state, payload){
      const setToken = payload[0]
      const userData = payload[1]
      localStorage.setItem('name',userData.name);
      localStorage.setItem('last_name',userData.name);
      localStorage.setItem('id',userData.id);
      localStorage.setItem('avatar',userData.avatar);
      localStorage.setItem('access',userData.access);
      localStorage.setItem('status',userData.status);
      localStorage.setItem('has_profile',userData.has_profile);
      state.user.name = userData.name;
      state.user.last_name = userData.last_name;
      state.user.id = userData.id;
      state.user.avatar = userData.avatar;
      state.user.access = userData.access;
      state.user.status = userData.status;
      state.user.has_profile = userData.has_profile;

      if(setToken){
        localStorage.setItem('token',userData.token)
        state.user.token = userData.token;
      }

      await this.dispatch('setCookie', 'expire_token');

    },
    clearStorage(state){
      document.cookie = 'expire_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      state.user.name = null;
      state.user.last_name = null;
      state.user.id = null;
      state.user.avatar = null;
      state.user.access = null;
      state.user.status = null;
      state.user.has_profile = false;
      state.user.token = null;
      localStorage.clear()
      state.basketCount = 0;
      state.baskets = [];
      state.basketAmount = 0;
      state.basketOriginalAmount = 0;
      state.discounts = 0;
      state.transportAmount = 0;
    }
  },
  actions: {
    setFavicon({state}, favicon){
      const icon = useFavicon()
      icon.value = favicon
    },
    async setCookie({state},name) {
      let expires = "";
      let date = new Date();
      let timestamp = date.setTime(date.getTime() + (24*60*60*100));
      expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + timestamp  + expires + "; path=/";
    },

    checkToken({state,commit}){
      axios.get(`${state.api}check-token`).then(resp=>{
        const data = resp.data.data;
        if(data.token_valid){
          if(data.status === 'no'){
            commit('clearStorage')
            window.location.href = '/error/403/دسترسی شما غیر فعال میباشد برای بررسی بیشتر با ما تماس بگیرید'
          }else{
            state.userPermissions = data.permissions;
            commit('setStorage',[false,data])
          }
        }else{
          commit('clearStorage')
          // window.location.href = `/error/401/توکن شما منقضی شده است لطفا دوباره وارد شوید`;
        }
      }).catch(err=>{
        console.log(err)
        commit('clearStorage')
        // window.location.href = `/error/401/توکن شما منقضی شده است لطفا دوباره وارد شوید`;
      })
    },

    async deleteRecord({commit,state},payload){
      await Swal.fire({
        title: "آیا از حذف این ایتم مطمئنید؟",
        text: payload[1],
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'بله',
        denyButtonText: `خیر`,

      }).then((willDelete) => {
        if (willDelete.isConfirmed) {
          state.isLoading  = true;
          axios.delete(state.api+payload[0]).then(resp=>{
            if(resp.data.status === 'success'){
              Swal.fire({
                title:'ایتم مورد نظر با موفقیت حذف شد',
                icon: "success",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `بستن`,
              });
            }else {
              Swal.fire({
                title:'حذف با خطا مواجه شد.',
                icon: "error",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `بستن`,
              });
            }
          }).catch(err=>{
            state.isLoading = false;
            commit('handleError',err)
          })
        }
      });
    },
  },
  getters: {
    numberFormat:(state)=>(number)=>{
      return new Intl.NumberFormat().format(number);
    },
    dateToPersian:(state)=>(date)=>{
      return new Date(date).toLocaleDateString('fa-IR-u-nu-latn');
    },

    getToken(state){
      return state.user.token;
    },
    getErrors(state){
      return state.errors;
    },
    getCookie: (state) => (name) => {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length,c.length)
        }
      }
      return null;
    },
    userCan: (state) => (permission,filter='') => {
      if(state.user.access === 'admin'){
        if(filter === 'include'){
          return state.userPermissions.filter(item=>item.includes(permission)).length > 0
        }else{
          return state.userPermissions.filter(item=>item === permission).length > 0
        }
      }else{
        return true;
      }
    },
    discount:(state,getters)=>(price, discount, numberFormat=true)=>{
      price = parseInt(price)
      price = price - ((parseInt(discount) / 100) * price);
      return numberFormat ? getters.numberFormat(price) : price;

    },
    copyToClipboard: (state) => async (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        Toast.success('کپی شد')
        await navigator.clipboard.writeText(text);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
          document.execCommand('copy');
          Toast.success('کپی شد')
        } catch (error) {
          console.error(error);
        } finally {
          textArea.remove();
        }
      }
    },

    readTime:(state)=>(content)=>{
      if(content !== null && content.length > 0){
        const words = content.split(' ');
        let timeForRead = Math.trunc((words.length * 0.12) / 60);
        return timeForRead === 0 ? 'کمتر از 1 دقیقه' : timeForRead + ' دقیقه '
      }else{
        return "کمتر از 1 دقیقه"
      }
    },
  },
  
})
